package com.example.mystybag.sharedmodels

/**
 * JS actual: lightweight wrapper for image data (e.g. from canvas or decoded bytes).
 * Used where Android has Bitmap and iOS has NSData.
 */
actual class SCImage(val data: ByteArray)
